<template>
  <div>
    <tab-bar currentActive="settings" @changeActive="changeTabbar"></tab-bar>
    <div class="container-fluid">
      <div class="row mt-5">
        <div class="col">
          <div class="position-relative w-100">
            <div class="position-absolute" style="z-index: 2000; top: -30px; right: 10px">
              <div class="rounded-circle d-flex align-items-center justify-content-center btn-icon"
                @click="$router.push('/settings').catch(err => { })" style="width: 30px; height: 30px; min-height: 0">
                <icon width="20" height="20" name="times"></icon>
              </div>
            </div>
          </div>
          <h1>CONTACTS</h1>
          <h2>NOS COORDONNÉES</h2>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col">
          <strong>Service administration des ventes</strong><br />
          Hôpital la Timone<br />
          264 rue Saint-Pierre<br />
          13005 Marseille<br />
        </div>
      </div>
      <div class="row">
        <div class="col">
          <hr />
        </div>
      </div>
      <div class="row">
        <div class="col">
          <strong>Qualités</strong><br />
          Hôpital la Timone<br />
          264 rue Saint-Pierre<br />
          13005 Marseille<br />
        </div>
      </div>
      <div class="row">
        <div class="col">
          <hr />
        </div>
      </div>
      <div class="row">
        <div class="col" v-if="!sent">
          <div>
            <label class="mt-2 mb-0" for="">Service</label>
            <select class="custom-select" v-model="service">
              <option value="">Choisir un service</option>
              <option value="Demande de matériel">Demande de matériel</option>
              <option value="Service qualité">Service qualité</option>
              <option value="Demande de contact">Demande de contact</option>
            </select>
          </div>
          <div>
            <label class="mt-2 mb-0" for="">Sujet</label>
            <m-form-text type="text" v-model="subject"></m-form-text>
          </div>
          <div>
            <label class="mt-2 mb-0" for="">Message</label>
            <textarea name="message" style="width: 100%" id="" cols="30" rows="5" v-model="message"></textarea>
          </div>
          <div class="mt-3">
            <button class="btn btn-primary" @click="send">Envoyer</button>
          </div>
        </div>
        <div class="col" v-else>
          <div class="alert alert-success">
            <p>Votre message a bien été envoyé. Nous vous répondrons dans les meilleurs délais.</p>
            <p>Vous pouvez nous contacter par téléphone au <strong>XX XX XX XX XX</strong></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Vue from "vue";
import { version } from "../../package.json";

export default {
  name: "home-settings",
  components: {},
  data() {
    return {
      notdisplayanymore: false,
      version,
      subject: "",
      message: "",
      service: "",
      sent: false
    };
  },
  async mounted() {
    window.scrollTo(0, 0);
    // console.log("this.$route.path", this.$route.path);
    this.$store.dispatch("addHistoryUrl", this.$route.path);
    // this.loadPatients();
    await this.$store.dispatch("setversion");
  },
  watch: {},
  computed: {},
  methods: {
    send() {
      if (!this.subject || !this.message || !this.service) {
        alert("Veuillez remplir le sujet, le message et choisir un service.");
        return;
      }
      this.sent = true;
    },
    gotoPerso() {
      this.$router.push("/settings/perso").catch(err => {});
    },
    changeTabbar(where) {
      if (where == "patients") {
        this.showPassed = false;
      }
    },
    reloadApp() {
      window.location.reload();
    }
  }
};
</script>

<style scoped lang="scss">
.m-form-checkbox {
  margin-bottom: 0;
}

.cguwin {
  position: fixed;
  background-color: white;
  border: 1px solid black;
  top: 5%;
  height: 90%;
  width: 90%;
  left: 5%;
  z-index: 10001;
  padding: 20px;

  // overflow: auto;
  .btn-jaccepte {
    position: absolute;
    bottom: 5px;
  }
}

.cguwin-content {
  overflow: auto;
}

@media (min-width: 576px) {
  .helpwin {}
}

@media (min-width: 768px) {
  .helpwin {}
}

.h-100vh {
  height: 100vh;
}

.bg-blue2 {
  background-color: rgb(161, 173, 194);
}

.topwhite {
  background-color: white;
  border-radius: 20px;
  padding: 20px;
}

.buttonsettings {
  width: 100%;
  text-align: left;
  background-color: rgb(237, 236, 236);
  border-radius: 10px;
  color: rgb(12, 40, 56);
  padding: 20px;
}
</style>
